import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function FontAwesomeIconTooltipped({icon, onClick, style, toolTipText}) {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {toolTipText}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <FontAwesomeIcon
        style={style}
        onClick={onClick}
        icon={icon}
      />
    </OverlayTrigger>
  );
}

export default FontAwesomeIconTooltipped;
